import { Nullable } from '@mosaik/core';
import { IDialogAction } from '../../../Interfaces/IDialogAction';
import { IDialogRef } from '../../Refs/Interfaces/IDialogRef';

/**
 * @public
 */
export interface IDialogProperties {
  header: string;

  content: string;

  actions: Array<IDialogAction<IDialogRef, any>>;

  isOpen: boolean;

  isFullScreen: boolean;

  clickOutsideToClose: boolean;

  pressEscapeToClose: boolean;

  hasCloseButton: boolean;

  isDraggable: boolean;

  hasBackdrop: boolean;

  focusOnOpen: boolean;

  result: Nullable<boolean>;
}

/**
 * @public
 */
export const defaultDialogProperties: IDialogProperties = {
  header: '',
  content: '',
  actions: new Array<IDialogAction<IDialogRef, any>>(),
  isOpen: false,
  clickOutsideToClose: false,
  pressEscapeToClose: false,
  hasCloseButton: true,
  isDraggable: true,
  isFullScreen: false,
  hasBackdrop: true,
  focusOnOpen: true,
  result: null
};
